<template>
  <div class="content">
    <div class="md:text-lg lg:text-xl font-bold">Похожие товары</div>
    <div
      class="mt-4 grid grid-cols-2 sm:grid-cols-4 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 w-full gap-y-5 gap-x-4 md:gap-x-5"
    >
      <Card
        v-for="(lot, index) in slicedLots"
        :key="lot.id"
        :lot="lot"
        style="display: inline-block"
        :page-name="pageName"
        :page-type="pageType"
        :source-block-type="'SIMILAR_PRODUCTS'"
        :show-insurance-text="showInsuranceText(index)"
      />
    </div>
    <RmBtn
      v-if="shortLots && slicedLots.length < edgesLots.length"
      class="text-blue-500 text-sm font-bold cursor-pointer leading-6 rounded-[12px] mx-auto mt-8 sm:max-w-150 w-full"
      color="yellow"
      type="button"
      @click="shortLots = false"
    >
      Показать ещё
    </RmBtn>
  </div>
</template>

<script>
import Card from '~/components/lots/display_type/card.vue'
import RmBtn from '~/components/shared/rm_btn.vue'

export default {
  components: {
    Card,
    RmBtn,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    lots: {
      type: Array,
      default: () => [],
    },
    pageName: {
      type: String,
      default: '',
    },
    pageType: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      shortLots: true,
    }
  },
  computed: {
    edgesLots () {
      if (this.lots?.length > 0) {
        return this.lots
      } else {
        return this.data.edges.map(edge => edge.node)
      }
    },
    pagination () {
      return this.data.pageInfo
    },

    slicedLots () {
      if (this.shortLots) {
        const { $breakpoints } = useNuxtApp()
        if ($breakpoints.xl) {
          return this.edgesLots.slice(0, 6 * 2)
        }
        if ($breakpoints.lLg) {
          return this.edgesLots.slice(0, 4 * 2)
        }
        if ($breakpoints.lMd) {
          return this.edgesLots.slice(0, 3 * 2)
        }
        if ($breakpoints.lSm) {
          return this.edgesLots.slice(0, 4 * 2)
        }
        return this.edgesLots.slice(0, 2 * 2)
      } else {
        return this.edgesLots
      }
    },
  },
  methods: {
    showInsuranceText (index) {
      const firstInsuranceIndex = this.slicedLots.findIndex(item => item?.category?.insurance)
      return firstInsuranceIndex === index
    },
  },
}
</script>
